export default __webpack_public_path__ + "static/media/DisabledIcon.b7c3f7f2.svg";